module.exports = __webpack_public_path__ + "img/border_Cube.896cb725.svg";